<script setup>
const props=defineProps(['entityType','entityId','isLiked','likes','views','size']);
const emit=defineEmits(['update:likes','update:isLiked']);
</script>
<template><CommonReaction v-bind="props" @update:likes="v=>emit('update:likes',v)" @update:isLiked="v=>emit('update:isLiked',v)" /></template>
